import { dbsliceData } from './dbsliceData.js';

function getFilteredTaskLabels() {

	return dbsliceData.filteredTaskLabels;

}

export { getFilteredTaskLabels };

